/** Серия дней: окно и карточка десктопа — чистая модель без DOM. */
import { type BalanceData, type StreakState } from "@newfungame/contracts";
import { STREAK_DAYS, streakReward } from "@newfungame/engine";

export type StreakDayStatus = "claimed" | "today" | "future";

export interface StreakDayView {
  day: number;
  coins: number;
  status: StreakDayStatus;
  /** 7-й день — большой мешок. */
  big: boolean;
}

/**
 * Семь дней серии: до текущего — забраны; текущий — «сегодня» (или забран, если `claimedToday`); после — впереди.
 * Награды — из баланса (`streak.rewards`), текущий день — `todayReward` от сервера.
 */
export function streakDays(b: BalanceData, streak: StreakState): StreakDayView[] {
  return Array.from({ length: STREAK_DAYS }, (_, i) => {
    const day = i + 1;
    const status: StreakDayStatus =
      day < streak.day || (day === streak.day && streak.claimedToday)
        ? "claimed"
        : day === streak.day
          ? "today"
          : "future";
    return {
      day,
      coins: day === streak.day ? streak.todayReward : streakReward(b, day),
      status,
      big: day === STREAK_DAYS,
    };
  });
}
